import { render, staticRenderFns } from "./mitra-bisnis.vue?vue&type=template&id=4dc928b8&scoped=true"
import script from "./mitra-bisnis.vue?vue&type=script&lang=js"
export * from "./mitra-bisnis.vue?vue&type=script&lang=js"
import style0 from "./mitra-bisnis.vue?vue&type=style&index=0&id=4dc928b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc928b8",
  null
  
)

export default component.exports